import React from 'react';
import { educationItems, professionalItems } from '../data/timeline';

const DotIcon = () => (
  <svg viewBox="0 0 10 10" fill="currentColor">
    <circle cx="5" cy="5" r="3.5" />
  </svg>
);

const TimelineItem = ({ item, accent }) => (
  <div className="timeline-item">
    <div className="timeline-dot-wrapper">
      <div className={`timeline-dot${accent ? ' accent' : ''}`}>
        <DotIcon />
      </div>
    </div>
    <div className="timeline-content">
      <div className="timeline-content-header">
        <h4 className="timeline-content-title">{item.title}</h4>
        {item.tag && <span className="timeline-tag">{item.tag}</span>}
      </div>
      <p className="timeline-date">{item.date}</p>
      {item.description && (
        <p className="timeline-description">{item.description}</p>
      )}
    </div>
  </div>
);

const TimelineSection = () => (
  <section id="timeline" className="section" style={{ background: 'var(--surface-secondary)' }}>
    <div className="container">
      <p className="section-label">Journey</p>
      <h2 className="section-title">Experience & Education</h2>

      <div className="timeline-cols">
        <div>
          <p className="timeline-col-heading">Professional Experience</p>
          <div className="timeline-list">
            {professionalItems.map((item, index) => (
              <TimelineItem key={index} item={item} accent={index === 0} />
            ))}
          </div>
        </div>

        <div>
          <p className="timeline-col-heading">Education</p>
          <div className="timeline-list">
            {educationItems.map((item, index) => (
              <TimelineItem key={index} item={item} accent={index === 0} />
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default TimelineSection;
